<div>
    <h2 data-testid="adx-payment-details-title" class="page-details-title-style">Payment {{paymentData.id}}</h2>
</div>

<app-adx-payment-info [data]="paymentData"></app-adx-payment-info>
